import{a as r}from"./chunk-RAAYCPUM.js";function l(...e){return r(u,e)}var u=(e,a,n)=>e.reduce(a,n);export{l as a};
